import React, { useState } from 'react';
import './Tooltip.scss';
const Tooltip = ({ children, text, ...rest }) => {
	const [show, setShow] = useState(false);

	return (
		<div className="TooltipContainer">
			<div className={show ? 'TooltipBox visible' : 'TooltipBox'}>
				{text}
				<span className="TooltipArrow" />
			</div>
			<div onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)} {...rest}>
				{children}
			</div>
		</div>
	);
};

export default Tooltip;
